import Icons from "../../assets/icon/index";
import { IoClose } from "react-icons/io5";
import {
  HoverButton,
  FormInput,
  PrefilledDropDown,
  Textarea,
  CheckBoxPreSelection,
  MultiplayCheckBoxPreSelection,
  DefaultValueCountry,
  Newlogo,
  MultiSelectDropdown,
  Text,
} from "../../components";
import { AiOutlinePlus } from "react-icons/ai";
import Functions from "./index.function";
import { BiSolidEdit } from "react-icons/bi";
import { fontSizes } from "../../constants/constants";
const TalentUpdate = () => {
  const {
    tabs,
    activeTab,
    setActiveTab,
    handleSubmit,
    onSubmit,
    control,
    errors,
    register,
    setValue,
    talentData,
    dropdowns,
    states,
    cities,
    desiredJobType,
    socialPlatforms,
    RadioValueandLable,
    links,
    linksErrors,
    selectedPlatform,
    setSelectedPlatform,
    addLink,
    updateLink,
    removeLink,
    setCountryCode,
    setCca2,
    otherLanguageId,
    otherExperienceId,
    isLoading,
    isLoadingprefilled,
    isLoadingStates,
    citiesisLoading,
    desiredJobTypeIsloading,
    loadingToapi,
    navigate,
    TextWeight,
  } = Functions();
  return (
    <div
      className={`bg-primary h-screen scroll-container xs:py-5 sm:py-8 lg:py-10`}
    >
      <div className="xs:pb-5 sm:pb-8 lg:pb-10 max-w-7xl lg:px-5 xl:px-10  sm:px-5 xs:px-3 m-auto">
        <div className="flex justify-center items-center relative xs:py-5">
          <Newlogo />
          <div className="absolute top-1/2 -translate-y-1/2 right-5 lg:right-10 xl:right-0">
            <div className="flex justify-between items-center gap-3">
              <Text
                text="Profile"
                color="text-secondary"
                size={fontSizes.h21}
                weight={TextWeight.Onest_regular}
              />
              <button
                onClick={() => navigate("/user-update")}
                className={`bg-[#707070] rounded-full transition-transform transform hover:scale-105 hover:shadow-md xs:w-7 xs:h-7 sm:w-8 sm:h-8 lg:w-10 lg:h-10 flex items-center justify-center`}
              >
                <BiSolidEdit className="text-secondary text-lg sm:text-xl lg:text-2xl" />
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="max-w-7xl lg:px-5 xl:px-10 sm:px-5 xs:px-3 mx-auto">
        <div className="flex justify-center items-center flex-col relative lg:py-8">
          <h1 className="uppercase text-secondary font-unboundedBold lg:text-3xl lg:leading-tight">
            Update Account (Talent)
          </h1>
        </div>
        <div className="w-full xs:my-4 xs:gap-y-2.5 xs:flex-wrap sm:my-6 flex justify-center items-center xs:gap-x-1 sm:gap-x-3 lg:gap-x-5 p-1 rounded-full">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              type="button"
              className={`group xs:w-[140px] xs:h-8 sm:w-40 ${
                activeTab === tab.key ? "gradient-container_btn" : ""
              } ${
                activeTab === tab.key ? "bg-transparent" : " bg-[#292929]"
              } sm:h-10 lg:w-48 xl:w-52 cursor-pointer flex lg:h-10 text-secondary font-onestMedium items-center justify-center rounded-full transition-transform transform hover:shadow-lg`}
            >
              <p className="text-secondary font-onestRegular xs:text-[10px] sm:text-xs lg:text-sm xl:text-base">
                {tab.label}
              </p>
            </button>
          ))}
        </div>
        <form
          className="flex justify-center items-center flex-col"
          onSubmit={handleSubmit(onSubmit)}
        >
          {activeTab === "personalInformation" && (
            <div
              className={
                "flex flex-col xs:w-full sm:w-[90%] lg:w-[60%] mx-auto sm:pt-4"
              }
            >
              <div className="w-full">
                <FormInput
                  label={"Stage Name"}
                  control={control}
                  isMandatory={true}
                  userData={talentData}
                  name="stage_name"
                  type="text"
                  errors={errors}
                  maxLength={30}
                  pattern={{
                    value: /^[A-Za-z\s]+$/,
                    message: "Stage Name can only contain letters",
                  }}
                  isLoading={isLoading}
                />
              </div>
              <div className="w-full">
                <FormInput
                  label={"Real Name"}
                  control={control}
                  isMandatory={true}
                  userData={talentData}
                  name="real_name"
                  type="text"
                  maxLength={30}
                  pattern={{
                    value: /^[A-Za-z\s]+$/,
                    message: "Real Name can only contain letters",
                  }}
                  errors={errors}
                  isLoading={isLoading}
                />
              </div>
              <div className="w-full">
                <FormInput
                  label={"Age"}
                  control={control}
                  isMandatory={true}
                  userData={talentData}
                  name="age"
                  type="number"
                  errors={errors}
                  isLoading={isLoading}
                  min={6}
                  max={90}
                  rules={{
                    required: "Age is required",
                    min: {
                      value: 6,
                      message: "Age must be at least 6",
                    },
                    max: {
                      value: 90,
                      message: "Age cannot be more than 90",
                    },
                  }}
                />
              </div>
              <div className="w-full">
                <FormInput
                  label={"Agent code"}
                  control={control}
                  isMandatory={true}
                  userData={talentData}
                  name="agent_code"
                  type="text"
                  maxLength={30}
                  isRequired={true}
                  // pattern={{
                  //     value: /^[A-Za-z\s]+$/,
                  //     message: 'Real Name can only contain letters',
                  // }}
                  errors={errors}
                  isLoading={isLoading}
                />
              </div>
              <div className="flex items-center sm:gap-x-6 xs:flex-col">
                <div className="relative xs:w-full sm:w-1/2 lg:w-1/2">
                  <PrefilledDropDown
                    control={control}
                    errors={errors}
                    rightIcon={Icons.arrowIcon}
                    isMandatory={true}
                    defaultValue={"Gender"}
                    label={"Gender"}
                    options={dropdowns?.gender}
                    valueName="gender"
                    valueoption="id"
                    name={"gender"}
                    isLoadingpreFiled={isLoadingprefilled}
                    isLoading={isLoading}
                  />
                </div>
                <div className="relative xs:w-full sm:w-1/2 lg:w-1/2">
                  <PrefilledDropDown
                    control={control}
                    errors={errors}
                    rightIcon={Icons.arrowIcon}
                    label={"Ethinicity"}
                    options={dropdowns?.ethnicity}
                    isMandatory={true}
                    valueName="name"
                    valueoption="ethnicity_id"
                    name={"ethinicity"}
                    isLoadingpreFiled={isLoadingprefilled}
                    isLoading={isLoading}
                  />
                </div>
              </div>
              <div className="w-full lg:pt-5">
                <Textarea
                  lable={"About Me"}
                  name={"about_me"}
                  register={register}
                  setValue={setValue}
                  errors={errors}
                  isMandatory={false}
                />
              </div>
            </div>
          )}
          {activeTab === "locationDetails" && (
            <div
              className={
                "flex flex-col xs:w-full sm:w-[90%] lg:w-[60%] mx-auto sm:pt-4"
              }
            >
              <div className="flex items-center sm:gap-x-6 xs:flex-col">
                <div className="relative xs:w-full sm:w-1/2 lg:w-1/2">
                  <PrefilledDropDown
                    control={control}
                    errors={errors}
                    rightIcon={Icons.arrowIcon}
                    label="Country"
                    options={dropdowns?.country || []}
                    isMandatory={true}
                    valueName="country"
                    valueoption="country_id"
                    name="countries"
                    isLoadingpreFiled={isLoadingprefilled}
                    isLoading={isLoading}
                  />
                </div>
                <div className="relative xs:w-full sm:w-1/2 lg:w-1/2">
                  <PrefilledDropDown
                    control={control}
                    errors={errors}
                    rightIcon={Icons.arrowIcon}
                    label={"Province / State"}
                    options={states}
                    valueName="state"
                    isMandatory={true}
                    valueoption="state_id"
                    name={"state_id"}
                    isLoadingpreFiled={isLoadingprefilled}
                    isLoading={isLoadingStates}
                  />
                </div>
              </div>
              <div className="w-full">
                <PrefilledDropDown
                  control={control}
                  errors={errors}
                  rightIcon={Icons.arrowIcon}
                  label={"City"}
                  options={cities}
                  isMandatory={true}
                  valueName="city"
                  valueoption="city_id"
                  name={"city_id"}
                  isLoadingpreFiled={isLoadingprefilled}
                  isLoading={citiesisLoading}
                />
              </div>
            </div>
          )}
          {activeTab === "contactInformation" && (
            <div
              className={
                "flex flex-col xs:w-full sm:w-[90%] lg:w-[60%] mx-auto sm:pt-4"
              }
            >
              <div className="w-full">
                <DefaultValueCountry
                  control={control}
                  label="Phone Number"
                  type="text"
                  name="mobile_number"
                  isMandatory={true}
                  defaultValue={talentData?.mobile_number}
                  countryCode={talentData?.country_code}
                  cca2={talentData?.cca2}
                  register={register}
                  onChange={(value) => setValue("mobile_number", value)}
                  errors={errors}
                  setCountryCode={setCountryCode}
                  setCca2={setCca2}
                />
              </div>
              <div className="xs:mb-1.5 xs:pl-6 sm:mb-2 sm:pl-6 lg:mb-2 lg:pl-8 xs:pt-1 lg:pt-1">
                <div className="xs:text-sm sm:text-base font-onestRegular text-secondary">
                  Social Media Profiles
                </div>

                {/* Dropdown & Add Button */}
                <div className="flex items-start xs:gap-x-2.5 sm:gap-x-3 my-2">
                  <div>
                    <select
                      value={selectedPlatform}
                      onChange={(e) => setSelectedPlatform(e.target.value)}
                      className="xs:text-sm sm:text-base bg-[#212121] text-[#B4B4B4] border border-goldMetallic rounded-full px-3 py-1.5 outline-none"
                    >
                      <option value="">Select Platform</option>
                      {socialPlatforms.map((platform) => (
                        <option key={platform} value={platform}>
                          {platform}
                        </option>
                      ))}
                    </select>

                    <div className="flex justify-start items-center xs:pt-[2px] sm:pt-1">
                      {linksErrors.platform && (
                        <div className="text-orangeCrayola font-onestRegular xs:!text-[10px] sm:text-xs">
                          {linksErrors.platform}
                        </div>
                      )}
                    </div>
                  </div>
                  <button
                    type="button"
                    onClick={addLink}
                    className="xs:px-3 flex items-center bg-[#171717] xs:py-1.5 sm:py-2 sm:px-4 rounded-full text-secondary border border-goldMetallic transition duration-300 delay-100"
                  >
                    <span className="xs:text-sm sm:text-base font-onestRegular">
                      Add link
                    </span>
                    <AiOutlinePlus className="xs:text-sm sm:text-base ml-3 text-goldMetallic" />
                  </button>
                </div>
                <div className="max-h-72 overflow-y-auto dashboard-scrollbar-cat">
                  {/* Dynamic Link Inputs */}
                  {links.map((link) => (
                    <>
                      <div
                        key={link.id}
                        className="flex items-center justify-between xs:pt-1.5 sm:pt-2 xs:w-4/5 sm:w-2/4 xs:gap-x-3 sm:gap-x-3"
                      >
                        <input
                          className="xs:rounded-[10px] sm:rounded-xl w-full sm:px-3 xs:py-1 xs:px-2 sm:py-2 bg-[#212121] text-[#B4B4B4] outline-none"
                          type="text"
                          placeholder={`Enter ${link.platform} link`}
                          value={link.url}
                          onChange={(e) => updateLink(link.id, e.target.value)}
                        />
                        <div
                          onClick={() => removeLink(link.id)}
                          className="group flex justify-center items-center xs:!w-[25px] xs:h-[22px] sm:w-7 sm:h-6 lg:w-8 lg:h-7 rounded-full bg-goldMetallic cursor-pointer transform transition-transform duration-300 hover:scale-110 hover:bg-red-700"
                        >
                          <IoClose className="text-black xs:text-lg sm:text-xl lg:text-2xl transform transition-transform duration-300 group-hover:rotate-180" />
                        </div>
                      </div>
                      <div className="flex justify-start items-center xs:pt-[2px] sm:pt-1">
                        {linksErrors.links[link.id] && (
                          <span className="text-orangeCrayola font-onestRegular xs:!text-[10px] sm:text-xs">
                            {linksErrors.links[link.id]}
                          </span>
                        )}
                      </div>
                    </>
                  ))}
                </div>
              </div>
              <div className="w-full">
                <FormInput
                  label={"Your Website"}
                  control={control}
                  userData={talentData}
                  name="your_website"
                  type="text"
                  maxLength={100}
                  pattern={{
                    value:
                      /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[\w-./?%&=]*)?$/,
                    message:
                      "Please enter a valid URL (e.g., https://example.com)",
                  }}
                  errors={errors}
                  isLoading={isLoading}
                  isRequired={true}
                />
              </div>
            </div>
          )}
          {activeTab === "physicalAttributes" && (
            <div
              className={
                "flex flex-col xs:w-full sm:w-[90%] lg:w-[60%] mx-auto sm:pt-4"
              }
            >
              <div className="w-full">
                <PrefilledDropDown
                  control={control}
                  errors={errors}
                  isLoadingpreFiled={isLoadingprefilled}
                  isLoading={isLoading}
                  rightIcon={Icons.arrowIcon}
                  isMandatory={true}
                  defaultValue={"Hair Types"}
                  label={"Hair Types"}
                  options={dropdowns?.hairTypes}
                  name={"hairTypes"}
                  valueName="name"
                  valueoption="hair_type_id"
                />
              </div>
              <div className="w-full">
                <FormInput
                  label={"Height"}
                  sublabel={"(cm)"}
                  control={control}
                  isMandatory={true}
                  userData={talentData}
                  name="height"
                  type="number"
                  maxLength={30}
                  validate={{
                    validHeight: (value) => {
                      const numericHeight = parseInt(value, 10);

                      if (isNaN(numericHeight))
                        return "Please enter a valid number";
                      if (numericHeight < 120)
                        return "Height must be at least 120 cm";
                      if (numericHeight > 220)
                        return "Height cannot exceed 220 cm";

                      return true;
                    },
                    maxLength: (value) =>
                      value.length <= 6 || "Height cannot exceed 6 characters",
                  }}
                  errors={errors}
                  isLoading={isLoading}
                />
              </div>
              <div className="w-full">
                <FormInput
                  label={"Weight"}
                  sublabel={"(kg)"}
                  control={control}
                  isMandatory={true}
                  userData={talentData}
                  name="weight"
                  type="number"
                  maxLength={6}
                  validate={{
                    validWeight: (value) => {
                      const numericWeight = parseInt(value, 10);
                      if (isNaN(numericWeight))
                        return "Please enter a valid number";
                      if (numericWeight < 25)
                        return "Weight must be at least 25 kg";
                      if (numericWeight > 90)
                        return "Weight cannot exceed 90 kg";
                      return true;
                    },
                    maxLength: (value) =>
                      value.length <= 6 || "Weight cannot exceed 6 characters",
                  }}
                  errors={errors}
                  isLoading={isLoading}
                />
              </div>
              <div className="w-full">
                <PrefilledDropDown
                  control={control}
                  errors={errors}
                  isLoadingpreFiled={isLoadingprefilled}
                  isLoading={isLoading}
                  rightIcon={Icons.arrowIcon}
                  isMandatory={true}
                  defaultValue={"Eye Colors"}
                  label={"Eye Colors"}
                  options={dropdowns?.eyeColors}
                  name={"eye_colors"}
                  valueName="name"
                  valueoption="eye_color_id"
                />
              </div>
              <div className="xs:mb-1.5 xs:pl-6 sm:mb-2 sm:pl-6 lg:mb-2 lg:pl-8 xs:pt-1 lg:pt-2">
                <CheckBoxPreSelection
                  control={control}
                  name="bodyTattoos"
                  isMandatory={true}
                  mapitems={RadioValueandLable}
                  errors={errors}
                  label="Body Modifications / Tattoos"
                />
              </div>
              <div className="xs:mb-1.5 xs:pl-6 sm:mb-2 sm:pl-6 lg:mb-2 lg:pl-8 xs:pt-1 lg:pt-1">
                <CheckBoxPreSelection
                  control={control}
                  name="bodyPiercings"
                  mapitems={RadioValueandLable}
                  register={register}
                  isMandatory={true}
                  errors={errors}
                  label="Body Modifications / Piercings"
                />
              </div>
            </div>
          )}
          {activeTab === "professionalPreferences" && (
            <div
              className={
                "flex flex-col xs:w-full sm:w-[90%] lg:w-[60%] mx-auto sm:pt-4"
              }
            >
              <div className="w-full xs:mb-1.5 sm:mb-2 lg:mb-2">
                <Textarea
                  lable={"Comments / Qualifications"}
                  name={"qualification"}
                  register={register}
                  isMandatory={true}
                  setValue={setValue}
                  errors={errors}
                />
              </div>
              <div className="xs:mb-1.5 sm:mb-2 lg:mb-2 xs:pt-1 lg:pt-1">
                <MultiSelectDropdown
                  control={control}
                  errors={errors}
                  rightIcon={Icons.arrowIcon}
                  isMandatory={true}
                  label={"Desired Job"}
                  // options={desiredJobType?.categories}
                  options={desiredJobType}
                  valueName="title"
                  valueoption="id"
                  name={"desired_job_types"}
                  isLoadingpreFiled={isLoadingprefilled}
                  isLoading={desiredJobTypeIsloading}
                />
              </div>
              <div className="w-full">
                <PrefilledDropDown
                  control={control}
                  errors={errors}
                  isLoadingpreFiled={isLoadingprefilled}
                  isLoading={isLoading}
                  rightIcon={Icons.arrowIcon}
                  isMandatory={true}
                  defaultValue={"Experience level"}
                  label={"Experience level"}
                  options={dropdowns?.experience}
                  valueName="job_experience"
                  valueoption="job_experience_id"
                  name={"experience"}
                />
              </div>
              {otherExperienceId == 52 && (
                <div className="w-full xs:mb-1.5 sm:mb-2 lg:mb-2">
                  <Textarea
                    lable={"Other Experience"}
                    name={"otherExperience"}
                    register={register}
                    isMandatory={true}
                    setValue={setValue}
                    errors={errors}
                  />
                </div>
              )}
              <div className="xs:mb-1.5 xs:pl-6 sm:mb-2 sm:pl-6 lg:mb-2 lg:pl-8 xs:pt-1 lg:pt-1">
                <MultiplayCheckBoxPreSelection
                  control={control}
                  name="languages_spoken"
                  items="lang"
                  mapitems={dropdowns?.languages} // Available languages
                  errors={errors}
                  isMandatory={true}
                  isRequired={true}
                  label="Languages Spoken"
                  selectedValues={talentData?.languages_spoken || []} // Pre-selected values
                />
              </div>
              {(Array.isArray(otherLanguageId)
                ? otherLanguageId.includes(195)
                : otherLanguageId == 195) && (
                <div className="w-full xs:mb-1.5 sm:mb-2 lg:mb-2">
                  <Textarea
                    lable={"Other Language"}
                    name={"otherLanguage"}
                    register={register}
                    isMandatory={true}
                    setValue={setValue}
                    errors={errors}
                  />
                </div>
              )}

              {/* <div className="w-full">
                                <PrefilledDropDown
                                    control={control}
                                    errors={errors}
                                    isLoadingpreFiled={isLoadingprefilled}
                                    isLoading={isLoading}
                                    rightIcon={Icons.arrowIcon}
                                      isMandatory={true}
                                    defaultValue={'Sexual Orientation'}
                                    label={'Sexual Orientation'}
                                    options={dropdowns?.sexualOrientation}
                                    name={"sexualOrientations"}
                                    valueName='name'
                                    valueoption='sexual_orientation_id'
                                />
                            </div> */}
            </div>
          )}
          <div
            className={`flex items-center justify-center xs:gap-x-3  xs:pt-5 sm:pt-6 sm:gap-x-6 xs:w-full sm:w-[90%] lg:w-[60%] mx-auto  `}
          >
            <HoverButton
              extraClasses={`group xs:h-10 sm:h-12 xs:w-1/2 sm:w-1/2 lg:w-1/2 cursor-pointer bg-cover flex lg:h-12 text-secondary font-onestMedium items-center justify-center rounded-full transition-transform transform ${
                loadingToapi ? "" : "hover:scale-105 hover:shadow-md"
              }`}
              BtnTitle={
                loadingToapi ? (
                  <div className="flex justify-center items-center">
                    <div className="animate-spin rounded-full border-t-2 border-b-2 border-secondary h-12 w-12 lg:w-10 lg:h-10  md:w-8 md:h-8 sm:w-10 sm:h-10 xs:w-8 xs:h-8"></div>
                  </div>
                ) : (
                  "Submit"
                )
              }
              disabled={loadingToapi}
              type={"submit"}
              BtnTitleClasses={`text-secondary font-onestSemiBold sm:text-sm lg:text-lg transition-transform transform ${
                loadingToapi
                  ? ""
                  : "group-hover:scale-110 group-hover:text-primary"
              }`}
            />
          </div>
        </form>
      </div>
    </div>
  );
};
export default TalentUpdate;
